import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=61677d55&scoped=true"
import script from "./comments.vue?vue&type=script&lang=ts"
export * from "./comments.vue?vue&type=script&lang=ts"
import style0 from "./comments.vue?vue&type=style&index=0&id=61677d55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61677d55",
  null
  
)

export default component.exports